const getUserId = state => state.view.id;

export default getUserId;
